import React, {
    useCallback,
    useEffect,
    useMemo,
    useState,
} from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import Calendar from '../../Calendar/Calendar';

import * as COMPANIES_SELECTORS from '../../../store/selectors/companies';

import { LOCALE_NAMESPACE } from '../../../const/translations/LOCALE_NAMESPACE';

import { emptyFunc } from '../../../helpers/function/emptyFunc';

import styles from './BuySubscriptionSelectDateDialog.module.scss';

const T_PREFIX = 'subscriptionsScreen.dialogs.buySelectDate';

const BuySubscriptionSelectDateDialog = (props) => {
    const {
        isVisible,
        onClose,
        onConfirm,
    } = props;

    const { t } = useTranslation(LOCALE_NAMESPACE.COMMON);

    const { tintColor } = useSelector(COMPANIES_SELECTORS.companiesSelector);

    const confirmButtonStyle = useMemo(() => ({
        background: tintColor,
    }), [tintColor]);

    const [timespan, setTimespan] = useState({
        year: moment().year(),
        month: moment().month(),
    });
    const [startDate, setStartDate] = useState(null);

    const handleChangeTimespan = useCallback((month, year) => {
        setTimespan({ year, month });
    }, []);

    const handleChangeDate = useCallback((date) => {
        setStartDate(date.startOf('day'));
    }, []);

    const handleConfirm = useCallback(() => {
        onConfirm({ startDate });
    }, [onConfirm, startDate]);

    useEffect(() => {
        if (!isVisible) {
            setStartDate(null);
        }
    }, [isVisible]);

    return (
        <Modal
            show={isVisible}
            container={document.getElementById('root_appybee_widget')}
            onHide={onClose}
        >
            <Modal.Header closeButton>
                <h4 className={styles.dialogTitle}>
                    {t(`${T_PREFIX}.header.title`)}
                </h4>
            </Modal.Header>

            <Modal.Body>
                <div className={styles.contentContainer}>
                    <span className={styles.contentTitle}>
                        {t(`${T_PREFIX}.body.title`)}
                    </span>
                    <div className={styles.calendarContainer}>
                        <Calendar
                            year={timespan.year}
                            month={timespan.month}
                            selectedDate={startDate}
                            showPastDates={false}
                            onSelectDate={handleChangeDate}
                            onChangeTimespan={handleChangeTimespan}
                            disabledDates={[]}
                            disabledDays={[]}
                        />
                    </div>
                </div>
            </Modal.Body>
            
            {startDate && (
                <Modal.Footer className={styles.dialogFooter}>
                    <Button
                        style={confirmButtonStyle}
                        className={styles.confirmButton}
                        onClick={handleConfirm}
                    >
                        {t(`${T_PREFIX}.body.actions.confirm`)}
                    </Button>
                </Modal.Footer>
            )}
        </Modal>
    );
};

BuySubscriptionSelectDateDialog.propTypes = {
    isVisible: PropTypes.bool,
    onClose: PropTypes.func,
    onConfirm: PropTypes.func,
};

BuySubscriptionSelectDateDialog.defaultProps = {
    isVisible: false,
    onClose: emptyFunc,
    onConfirm: emptyFunc,
};

export default BuySubscriptionSelectDateDialog;
